import React from "react";

import styles from "./ListCard.module.scss";
import moment from "moment";
import { Link } from "react-router-dom";
import { route } from "../../static/route";
import { JobworkProps } from "../../types/jobwork";
import JobworkCloseForm from "./JobworkCloseForm";

type Props = {
  jobwork: JobworkProps;
  index?: number | undefined;
};

const ListCard = ({ jobwork, index }: Props) => {
  return (
    <div className={styles.ListCard}>
      <h5 className="text-primary-1 text-lg font-semibold">
        કામ નું આઇડી : {jobwork.id}
      </h5>

      <div className="flex flex-col gap-3 mt-5">
        <p className="text-primary-1 text-sm font-semibold">
          પાર્ટી :{" "}
          {jobwork.party.name +
            (jobwork.party.phone ? " (" + jobwork.party.phone + ")" : "")}
        </p>
        <p className="text-primary-1 text-sm font-semibold">
          આઈટમ : {jobwork.item.name}
        </p>
        <p className="text-primary-1 text-sm font-semibold">
          ટાઇપ : {jobwork.type === 1 ? "ખોલવા આપેલ" : "બાંધવા આપેલ"}
        </p>
        <p className="text-primary-1 text-sm font-semibold">
          આઈટમ નો વજન : {jobwork.i_weight}
        </p>
        {jobwork.type === 0 && (
          <p className="text-primary-1 text-sm font-semibold">
            તાર નો વજન : {jobwork.t_weight}
          </p>
        )}
        {jobwork.status === 1 && (
          <>
            <p className="text-primary-1 text-sm font-semibold">
              ડિલિવર કરેલ વજન : {jobwork.i_delivered_weight}
            </p>

            <p className="text-primary-1 text-sm font-semibold">
              ડિલિવર કરેલ તારીખ :{" "}
              {moment(jobwork.delivered_date, "YYYY-MM-DD HH:mm:ss").format(
                "DD-MM-YYYY hh:mm A"
              )}
            </p>
          </>
        )}
        <p className="text-primary-1 text-sm font-semibold">
          માલ ની પાર્ટીઓ :{" "}
          {jobwork?.order_parties?.map((order_party, index) => (
            <span key={order_party.id}>
              {index > 0 && ", "}
              {order_party.party.firm_name +
                (order_party.party.phone
                  ? " (" + order_party.party.phone + ")"
                  : "")}
            </span>
          ))}
        </p>
      </div>

      {index !== undefined && index >= 0 ? (
        <JobworkCloseForm index={index} />
      ) : (
        <Link
          to={route.jobworkDetails
            .replace(":jobworkId", jobwork.id.toString())
            .replace(":typeId", jobwork.type === 1 ? "2" : "1")}
        >
          <button
            className="mx-auto flex gap-3 mt-6 shadow disabled:opacity-50 rounded-3xl text-1xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2"
            type="button"
          >
            કામ ની વિગતો જુઓ
          </button>
        </Link>
      )}
    </div>
  );
};
export default ListCard;
